import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { singnUp } from '../../service/api';
import Button from 'react-bootstrap/Button';
import LoadingEllipsis from '../../components/LoadingEllipsis/LoadingEllipsis';
import './styles/Sign.css';

import bckgVideo from '../../assets/video/water2.mp4';
import fallbackVideo from '../../assets/video/lemons.mp4';
import fallbackImg from '../../assets/img/fallback.webp';
import fallbackMobileImg from '../../assets/img/ban1.webp';

function Sign() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const videoRef = useRef();
  const [videoError, setVideoError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const handleVideoError = () => {
    setVideoError(true);
  };

  const initialValues = {
    email: '',
    first_name: '',
    last_name: ''
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Email inválido')
      .required('Campo obrigatório'),
    first_name: Yup.string()
      .min(3, 'Mínimo 3 caracteres')
      .required('Campo obrigatório'),
    last_name: Yup.string()
      .min(3, 'Mínimo 3 caracteres')
      .required('Campo obrigatório')
  });

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      const response = await singnUp(values.email, values.first_name, values.last_name);
      setMessage(response.data.message || 'Formulário enviado com sucesso!');
      resetForm();
      setTimeout(() => {
        navigate('/');
      }, 4000);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.includes('registrado com Google/Facebook')
      ) {
        setMessage(error.response.data);
        setTimeout(() => {
          navigate('/login');
        }, 4000);
      } else if (error.response && error.response.data) {
        setMessage(error.response.data);
      } else {
        setMessage('Erro ao enviar o formulário');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (message) {
      const timeout = setTimeout(() => {
        setMessage("");
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [message]);



  return (
    <>
      <div className="signVideoBox">
        {isMobile ? (
          <img src={fallbackMobileImg} className="loginFallbackImg" alt="Fallback MobileImage" />
        ) : !videoError ? (
          <video ref={videoRef} muted autoPlay loop onError={handleVideoError}>
            <source src={bckgVideo} type="video/mp4" onError={() => videoRef.current.src = fallbackVideo} />
            <source src={fallbackVideo} type="video/mp4" />
          </video>
        ) : (
          <img src={fallbackImg} className="loginFallbackImg" alt="FallbackImage" />
        )}
      </div>

      <div className='sign-container'>
        <div className="title">
          <span>Bem-vindo comece aqui seu registro</span>
        </div>
        <div className="signBox">
          <span> Comece aqui o seu Registro </span>
          {loading && <div className="messages"> <LoadingEllipsis message="Aguarde" /></div>}
          {message && <div className="messages"> {message} </div>}

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Field
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  autoComplete="email"
                />
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="first_name">Nome</label>
                <Field
                  name="first_name"
                  type="text"
                  className="form-control"
                  placeholder="Nome"
                />
                <ErrorMessage name="first_name" component="div" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="last_name">Sobrenome</label>
                <Field
                  name="last_name"
                  type="text"
                  className="form-control"
                  placeholder="Sobrenome"
                />
                <ErrorMessage name="last_name" component="div" className="error-message" />
              </div>

              <div className="exitLink">
                <a href="/">sair</a>
              </div>

              <div className="loginBtn">
                <Button className="form-btn btn" variant="primary" type="submit">Enviar</Button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>

      <div className="footerLogin">
        <div className='year'>2007 - <span>{currentYear}</span></div>
        <div>&copy; todos os direitos reservados</div>
        <div>powered by <span className='brand'>apit solutions</span></div>
      </div>
    </>
  );
}

export default Sign;
